// AllProducts.jsx
import React, { useEffect, useState } from 'react';
import { summaryApi } from '../../common';
import { Plus, Search } from 'lucide-react';
import { useTheme } from '../../components/Theme/ThemeProvider';
import UploadProducts from './UploadProducts';
import ProductCard from './ProductCard';
import { authFetch } from '../../helpers/authFetch';

function AllProducts() {
    const { colors } = useTheme();
    const [openUploadProduct, setOpenUploadProduct] = useState(false);
    const [allProducts, setAllProducts] = useState([]); 
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchAllProducts = async() => {
        const response = await authFetch(summaryApi.allProducts.url,{
            method: summaryApi.allProducts.method,
            
        });
        const responseData = await response.json();
        setAllProducts(responseData?.data || []);
        setFilteredProducts(responseData?.data || []);
    };

    useEffect(() => {
        fetchAllProducts();
    }, []);

    useEffect(() => {
        const filtered = allProducts.filter(product => 
            product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.productBrand?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.productsCategory?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredProducts(filtered);
    }, [searchTerm, allProducts]);

    return (
        <div className="space-y-6 animate-fadeIn">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-4xl font-bold" style={{ color: colors.text }}>
                        All Products
                    </h1>
                    <p className="mt-1" style={{ color: colors.textSecondary }}>
                        Manage your product inventory ({filteredProducts.length})
                    </p>
                </div>
                <button 
                    onClick={() => setOpenUploadProduct(true)}
                    className="inline-flex items-center space-x-2 px-6 py-3 text-white font-medium rounded-lg transition-all transform hover:scale-105 hover:shadow-lg group"
                    style={{
                        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
                    }}
                >
                    <Plus className="w-5 h-5 transition-transform group-hover:rotate-90" />
                    <span>Add Product</span>
                </button>
            </div>

            {/* Search Bar */}
            <div className="relative group">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 transition-all" style={{ color: colors.textSecondary }} />
                <input
                    type="text"
                    placeholder="Search products by name, brand, or category..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 rounded-lg outline-none transition-all duration-300 group-hover:shadow-lg"
                    style={{
                        backgroundColor: colors.bgSecondary,
                        color: colors.text,
                        border: `2px solid ${colors.border}`,
                        boxShadow: searchTerm ? `0 0 0 3px ${colors.primary}20` : 'none'
                    }}
                />
            </div>

            {/* Products Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filteredProducts.map((item, index) => (
                    <ProductCard
                        fetchData={fetchAllProducts}
                        data={item}
                        key={index + "allProduct"}
                    />
                ))}
            </div>

            {filteredProducts.length === 0 && (
                <div className="text-center py-16 rounded-lg" style={{ backgroundColor: colors.bgSecondary }}>
                    <p style={{ color: colors.textSecondary }} className="text-lg">
                        No products found
                    </p>
                </div>
            )}

            {openUploadProduct && (
                <UploadProducts
                    onClose={() => setOpenUploadProduct(false)}
                    fetchData={fetchAllProducts}
                />
            )}

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeIn {
                    animation: fadeIn 0.3s ease-out;
                }
            `}</style>
        </div>
    );
}

export default AllProducts;
